import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ToolboxToolBlueprint } from '@drodil/backstage-plugin-toolbox';

const markdownToPdfTool = ToolboxToolBlueprint.make({
  name: 'markdown-to-pdf',
  params: {
    id: 'markdown-to-pdf',
    displayName: 'Markdown to PDF',
    description: 'Render Markdown and export it as a PDF',
    category: 'Convert',
    aliases: ['md', 'pdf', 'markdown', 'export', 'print'],
    loader: async () => {
      const { MarkdownToPdf } = await import('./MarkdownToPdf');
      return <MarkdownToPdf />;
    },
  },
});

export const toolboxModule = createFrontendModule({
  pluginId: 'toolbox',
  extensions: [markdownToPdfTool],
});
